import { DataTableCol } from "../../../components/tables/types";

export const QuestionsListDataGridCols: DataTableCol[] = [
    {
        title: 'Question Name',
        control: 'question',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Correct Answer',
        control: 'correctAnswer',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];